import { render, staticRenderFns } from "./XiangMu2_获嘉版本.vue?vue&type=template&id=4086449c&scoped=true"
import script from "./XiangMu2_获嘉版本.vue?vue&type=script&lang=js"
export * from "./XiangMu2_获嘉版本.vue?vue&type=script&lang=js"
import style0 from "./XiangMu2_获嘉版本.vue?vue&type=style&index=0&id=4086449c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4086449c",
  null
  
)

export default component.exports